import Vue from 'vue';
// import { ContentLoader } from 'vue-content-loader';

/* Global Components */
// Vue.component('ContentLoader', ContentLoader);
Vue.component('vue-headful', () => import('vue-headful'));
// Vue.component('cookie-law', () => import('vue-cookie-law'));

Vue.component('Debug', () => import('@/components/Debug'));
